import { createTheme } from '@material-ui/core/styles';

export const theme = createTheme({
    palette: {
        primary: {
            main: '#006699',
            light: '#1b90fa'
        },
        error: { main: '#ef1734' }
    },
    overrides: {
        MuiTypography: {
            root: {
                fontFamily: 'inherit !important'
            },
            body1: {
                fontFamily: 'inherit',
                fontSize: '1em'
            }
        },
        MuiMenuItem: {
            root: {
                fontFamily: 'inherit',
                fontSize: '13px',
                color: '#636566'
            }
        },
        MuiFormLabel: {
            root: {
                fontFamily: 'inherit'
            }
        },
        MuiInput: {
            formControl: {
                marginTop: '0 !important'
            },
            underline: {
                '&:hover:not(.Mui-disabled):before': {
                    borderBottom: 'none'
                },
                '&:before': {
                    borderBottom: 'none',
                    borderBottomStyle: 'none !important'
                },
                '&:after': {
                    borderBottom: 'none'
                }
            }
        },
        MuiInputBase: {
            root: {
                fontFamily: 'inherit',
                borderRadius: '4px'
            },
            input: {
                fontSize: '14px',
                border: 'none',
                color: '#363636',
                borderRadius: '4px',
                '&:-webkit-autofill': {
                    borderRadius: '9px'
                }
            }
        },
        MuiPaper: {
            root: {
                color: '#3d454a'
            }
        },
        MuiSelect: {
            icon: {
                right: 'auto',
                left: '0'
            },
            select: {
                paddingLeft: '24px',
                paddingRight: '10px',
                borderRadius: '4px',
                '&:focus': {
                    borderRadius: '4px',
                    backgroundColor: '#f5f7fa'
                }
            }
        },
        MuiButton: {
            root: {
                fontFamily: 'inherit',
                fontSize: '15px',
                textTransform: 'none',
                borderRadius: '6px',
                height: '40px'
            },
            contained: {
                backgroundColor: '#1b90fa',
                color: 'white',
                border: 'solid 1px #1b90fa',
                '&:hover': {
                    backgroundColor: '#063f5e'
                    // border: 'solid 1px #063f5e',
                }
            },
            outlined: {
                backgroundColor: '#fff',
                color: '#ee384e',
                border: 'solid 2px #ee384e',
                '&:hover': {
                    backgroundColor: '#ee384e',
                    color: '#fff'
                }
            },
            // this variant is used for the cancel or delete button
            containedPrimary: {
                backgroundColor: '#1b90fa'
            }
        },
        MuiRadio: {
            colorSecondary: {
                '&$checked': {
                    color: '#006699'
                }
            }
        },
        MuiAutocomplete: {
            endAdornment: {
                left: '0',
                right: 'auto'
            },
            popper: {
                color: 'red'
            },
            clearIndicator: {
                marginLeft: '12px',
                color: '#b3b3b3'
            }
        },
        MuiSnackbar: {
            root: {
                fontFamily: 'inherit',
                whiteSpace: 'pre',
                '& *': {
                    fontFamily: 'inherit !important'
                },
                '& img': {
                    position: 'absolute',
                    left: '10px',
                    top: '14px',
                    cursor: 'pointer'
                }
            }
        },
        MuiTooltip: {
            tooltip: {
                fontFamily: 'inherit',
                backgroundColor: '#05324a'
            }
        },
        MuiList: {
            padding: {
                paddingTop: '0',
                paddingBottom: '0'
            }
        },
        MuiDialogContent: {
            root: {
                paddingTop: '27px'
            }
        },
        MuiChip: {
            root: {
                height: '27px'
            },
            label: {
                paddingLeft: '7px'
            }
        },
        MuiSvgIcon: {
            root: {
                width: '1rem'
            }
        },
        MuiIconButton: {
            root: {
                // padding: '10px'
            }
        },
        MuiTableCell: {
            root: {
                fontFamily: 'inherit',
                textAlign: 'inherit'
            }
        },
        MuiListItem: {
            root: {
                textAlign: 'inherit'
            }
        },
        MuiFab: {
            root: {
                zIndex: '10'
            }
        }
    }
});
